import _orderBy from 'lodash.orderby';
import _debounce from 'lodash.debounce';
import Vue from 'vue';
import Errors from '../classes/errors';
import { setCaptchaEuScript } from '../utils';

Vue.component('brandstore-search-component', {
    props: {
        stores: {
            value: Object,
        },
        isParentGeocoderInit: {
            value: Boolean,
            default: false,
        },
        brandstoreResultAmount: {
            value: Number,
        },
        siteHandle: {
            value: String,
        },
        errors: {
            value: new Errors(),
        },
        inputId: {
            value: String,
        },
    },

    data() {
        return {
            selectedBrandStore: null,
            search: '',
            dropdownStore: null,
            countryHandle: '',

            geocoder: null,

            // Dealer search (zip code vars)
            showDropdown: false,
            cityNotFound: false,
            store: '',
            zipCoords: null,
            searchQueryIsDirty: false,
            nearbyProximityStores: null,
            needMoreInput: false,
            apiRequestLoading: false,

            countryValue: {
                mgMotorsNetherlands: 'NL',
                mgMotorsBelgiumNl: 'BE',
                mgMotorsBelgiumFr: 'BE',
                mgMotorsAustria: 'AT',
                mgMotorsDanmark: 'DK',
                mgMotorsGermany: 'DE',
                mgMotorsSpain: 'ES',
                mgMotorsFrance: ['FR', 'MQ', 'GF', 'GP', 'RE', 'YT'],
                mgMotorsIceland: 'IS',
                mgMotorsItaly: 'IT',
                mgMotorsLuxembourgFr: 'LU',
                mgMotorsNorway: 'NO',
                mgMotorsPortugal: 'PT',
                mgMotorsSweden: 'SE',
                mgMotorsSwitzerlandIt: 'CH',
                mgMotorsSwitzerlandFr: 'CH',
                mgMotorsSwitzerlandDe: 'CH',
                mgMotorsFinland: 'FI',
                guyane: 'GF',
                martinique: 'MQ',
                mayotte: 'YT',
                reunion: 'RE',
                guadeloupe: 'GP',
                mgMotorsSwitzerlandIt: 'CH',
                mgMotorsSwitzerlandFr: 'CH',
                mgMotorsSwitzerlandDe: 'CH',
                mgMotorsHungary: 'HU',
            },

            selectedFrBrandStore: '',
            internalCountryHandle: '',
            frBrandStoreHandle: '',
            dropdownFrStore: '',
            dropdownFrStoreValue: '',
            frBrandStores: {
                martinique: 'MG Martinique (97232 Le Lamentin)',
                guadeloupe: 'MG Guadeloupe (97122 Baie-Mahault)',
                guyane: 'MG Guyane (97324 Cayenne Cedex)',
                mayotte: 'MG Mayotte (97 600 Mamoudzou)',
            },

            guyane: 'GF',
            martinique: 'GF',
            mayotte: 'YT',
            reunion: 'RE',
            guadeloupe: 'GP',
        };
    },

    computed: {
        moreThenTwoStores() {
            if (!this.countryHandle) {
                return false;
            }
            return Object.keys(this.stores).length > 2;
        },
        hasBrandStores() {
            if (!this.countryHandle) {
                return false;
            }
            return Object.keys(this.stores).length > 0;
        },
        orderedStores() {
            return _orderBy(this.stores, 'title');
        },

        toggleClasses() {
            return `${this.handleShowContainerError()} ${this.isDropdownActive()}`;
        },

        toggleDropdownClasses() {
            return `${this.isDropdownActive()}`;
        },
    },

    watch: {
        store(value) {
            const isSearchBrandstoreInvalid = value.length < 3;
            const isSelectedBrandstoreEqualSearchBrandstore =
                this.selectedBrandStore &&
                this.selectedBrandStore.title === value;

            if (value.length === 0) {
                this.resetErrorState();
                return;
            }

            if (isSearchBrandstoreInvalid) {
                this.apiRequestLoading = false;
                this.needMoreInput = true;
                this.nearbyProximityStores = null;
                this.showDropdown = false;
                return;
            }

            if (isSelectedBrandstoreEqualSearchBrandstore) {
                return;
            }
            this.selectedBrandStore = null;
            this.needMoreInput = false;
            this.searchByZipGoogleApi();
        },

        selectedBrandStore(value) {
            this.showDropdown = false;
            if (!value) return;

            document.getElementById(this.inputId).value = this.store;

            EventBus.$emit('brandstore-selected', value);
            EventBus.$emit('brandstore-dropdown-value-selected', {
                store: JSON.stringify(value),
                inputId: this.inputId,
            });
        },

        countryHandle() {
            this.dropdownStore = null;
        },
    },

    mounted() {
        if (this.siteHandle !== 'default') {
            this.countryHandle = this.siteHandle;
        }
        setCaptchaEuScript();
        EventBus.$once('google-maps-ready', this.initMap);

        // For cases where the parent component is not the configurator component.
        // Since configurator component needs to init geocoder that's used in configurator stock,
        // we need to ensure that google maps aren't injected more than once since it's creating bugs that way.
        if (!this.isParentGeocoderInit) {
            this.injectGoogleMaps();
        }

        this.preselectOneBrandstore();
    },

    methods: {
        isDropdownActive() {
            return this.zipCoords ? 'dropdown-active' : '';
        },

        handleShowContainerError() {
            return this.needMoreInput || this.cityNotFound
                ? 'new-input__dropdown-container--error'
                : '';
        },

        preselectOneBrandstore() {
            if (this.siteHandle == 'mgMotorsIceland') {
                const firstElement = Object.values(this.stores)[0];
                if (firstElement) {
                    this.selectedBrandStore = firstElement;
                    this.store = this.selectedBrandStore.title;
                }
            }
        },
        handleAddErrorClass() {
            return this.isErrorOnStoreInput
                ? 'new-input__container--error'
                : '';
        },

        resetErrorState() {
            this.selectedBrandStore = null;
            this.showDropdown = false;
            this.needMoreInput = false;
            this.cityNotFound = false;
        },

        setCityNotFound() {
            this.showDropdown = false;
            this.needMoreInput = false;
            this.cityNotFound = true;
        },

        initMap() {
            // Adding Google maps Geocoder
            this.geocoder = new google.maps.Geocoder();
        },

        setInputLengthError() {
            this.needMoreInput = true;
            this.nearbyProximityStores = null;
        },

        injectGoogleMaps() {
            let tag = document.createElement('script');
            tag.setAttribute('type', 'text/javascript');
            tag.defer = true;
            tag.async = true;
            tag.setAttribute(
                'src',
                '//maps.google.com/maps/api/js?key=AIzaSyBXLteX7ErcVvjvFLHB1_TMCzq55wVb5Bg&libraries=places&callback=mapsCallback',
            );
            (
                document.getElementsByTagName('head')[0] ||
                document.documentElement
            ).appendChild(tag);
        },

        searchByZipGoogleApi: _debounce(function () {
            this.makeApiRequest();
        }, 300),

        makeApiRequest() {
            this.apiRequestLoading = true;

            let tempStore = this.store;

            let code = this.countryValue[this.internalCountryHandle];
            if (!code) {
                code = this.countryValue[this.siteHandle];
            }

            if (this.siteHandle === 'mgMotorsFrance') {
                code = undefined;

                // map country code to DROM code
                if (tempStore.startsWith('974')) {
                    // cover for FR 97407 -> 97420 Le Port, Réunion
                    if (this.store === '97407') {
                        tempStore = '97420 Le Port, Réunion';
                    }
                    code = 'RE';
                }

                if (tempStore.startsWith('971')) {
                    code = 'GP';
                }

                if (tempStore.startsWith('972')) {
                    code = 'MQ';
                }

                if (tempStore.startsWith('973')) {
                    code = 'GF';
                }

                if (tempStore.startsWith('976')) {
                    code = 'YT';
                }
            }

            if (this.siteHandle.includes('Switzerland')) {
                code = this.countryValue[this.siteHandle];
            }

            if (this.siteHandle === 'mgMotorsNorway') {
                code = 'NO';

                // Svalbard and Jan Mayen
                const locations = [
                    { code: '8099', name: 'Jan Mayen' },
                    { code: '9170', name: 'Longyearbyen' },
                    { code: '9171', name: 'Longyearbyen' },
                    { code: '9172', name: 'Isfjord' },
                    { code: '9173', name: 'Ny-Ålesund' },
                    { code: '9174', name: 'Hopen' },
                    { code: '9175', name: 'Sveagruva' },
                    { code: '9176', name: 'Bjørnøya' },
                    { code: '9177', name: 'Hornsund' },
                    { code: '9178', name: 'Barentsburg' },
                ];

                locations.forEach((location) => {
                    if (
                        location.code.includes(tempStore) ||
                        location.name.includes(tempStore)
                    ) {
                        code = 'SJ';
                        tempStore = `${location.code} ${location.name}`;
                    }
                });
            }

            const requestParams = {
                address: tempStore,
                componentRestrictions: {
                    country: code,
                },
            };

            this.geocoder.geocode(requestParams, (results, status) => {
                if (status === 'OK' && results.length) {
                    const [res] = results;
                    this.apiRequestLoading = false;
                    const isDefaultLocation =
                        res.address_components.length === 1 &&
                        res.address_components[0].short_name === code;

                    //check if geocoder returns default coordination - no results for search
                    if (this.siteHandle !== 'mgMotorsNorway') {
                        if (isDefaultLocation) {
                            this.setCityNotFound();
                            return;
                        }
                    }

                    this.showDropdown = true;

                    this.zipCoords = {
                        lat: res.geometry.location.lat(),
                        lng: res.geometry.location.lng(),
                    };

                    if (!this.zipCoords || this.stores.length < 1) return;

                    this.getNearbyBrandstores(this.zipCoords, this.stores);
                    return;
                }

                this.apiRequestLoading = false;
                this.setCityNotFound();
                console.error(
                    'Geocode was not successful for the following reason: ' +
                        status,
                );
            });
        },

        getNearbyBrandstores(userLocation, brandstores) {
            const storesWithDistance = Object.values(brandstores).map(
                (store) => {
                    const distance = this.getDistance(userLocation, store);
                    return {
                        ...store,
                        distance,
                    };
                },
            );

            this.cityNotFound = false;

            this.nearbyProximityStores = storesWithDistance
                .sort((a, b) => {
                    if (a.distance < b.distance) {
                        return -1;
                    }

                    if (a.distance > b.distance) {
                        return 1;
                    }

                    return 0;
                })
                .slice(0, this.brandstoreResultAmount);
        },

        getDistance(userLocation, brandstore) {
            // Bron: https://cloud.google.com/blog/products/maps-platform/how-calculate-distances-map-maps-javascript-api
            var radius = 6371.071; // Radius of the Earth in KM

            const radiusLat1 = userLocation.lat * (Math.PI / 180); // Convert degrees to radians
            const radiusLat2 = brandstore.lat * (Math.PI / 180); // Convert degrees to radians
            const differenceLat = radiusLat2 - radiusLat1; // Radian difference (latitudes)
            const differenceLng =
                (brandstore.lng - userLocation.lng) * (Math.PI / 180); // Radian difference (longitudes)

            const distance =
                2 *
                radius *
                Math.asin(
                    Math.sqrt(
                        Math.sin(differenceLat / 2) *
                            Math.sin(differenceLat / 2) +
                            Math.cos(radiusLat1) *
                                Math.cos(radiusLat2) *
                                Math.sin(differenceLng / 2) *
                                Math.sin(differenceLng / 2),
                    ),
                );

            return distance;
        },

        replaceInputValue(e) {
            e.preventDefault();
            this.selectedBrandStore = this.stores[e.target.dataset.value];
            this.store = this.selectedBrandStore.title;

            // Reset zipCoords to null
            this.zipCoords = null;
        },
    },
});
